
export default {
  name: 'StockStatus',
  props: {
    product: {
      type: Object,
      required: true,
    },
    quantity: {
      type: Number,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inStock() {
      return (
        this.product.variant.quantity_available > 0 &&
        this.quantity <= this.product.variant.quantity_available
      )
    },
    showFreeShipping() {
      const offer = this.$store.getters.free_shipping_offer

      return (
        this.small &&
        this.inStock &&
        !!offer &&
        !offer.relay &&
        this.product.variant.user_price_ttc >= offer.amount
      )
    },
    stockClass() {
      return {
        '!tw-text-[9px]': this.small,
        'tw-text-base': !this.small,
        'tw-text-green-700':
          this.inStock ||
          this.product.variant.out_of_stock_status_id === 3 ||
          this.showFreeShipping,
        'text-danger':
          !this.inStock &&
          (this.product.variant.out_of_stock_status_id === 1 ||
            this.product.variant.out_of_stock_status_id === 4),
        'tw-text-amber-700':
          this.product.variant.out_of_stock_status_id === 2 &&
          this.product.variant.quantity_available <= 0,
      }
    },
    stockStatus() {
      if (this.showFreeShipping) {
        return {
          text: this.$t('components.productStockStatus.freeShipping'),
          icon: ['fas', 'truck'],
        }
      }
      if (this.inStock) {
        return {
          text: this.$t('components.cartProductList.inStock'),
          icon: ['fas', 'check-circle'],
        }
      }
      switch (this.product.variant.out_of_stock_status_id) {
        case 4:
          return {
            text: this.small
              ? this.$t('components.productStockStatus.permanentStockOutShort')
              : this.$t('components.productStockStatus.permanentStockOutLong'),
            icon: ['fal', 'times'],
          }
        case 3:
          return {
            text: this.$t('components.cartProductList.inStock'),
            icon: ['fas', 'check-circle'],
          }
        case 2:
          return {
            text: this.small
              ? this.$tc(
                  'components.productStockStatus.onOrderShortDelay',
                  this.product.variant.reorder_delay_max,
                  {
                    minDelay: this.product.variant.reorder_delay_min,
                    maxDelay: this.product.variant.reorder_delay_max,
                  }
                )
              : this.$tc(
                  'components.cartProductList.onOrder',
                  this.product.variant.reorder_delay_max,
                  {
                    minDelay: this.product.variant.reorder_delay_min,
                    maxDelay: this.product.variant.reorder_delay_max,
                  }
                ),
            icon: ['fas', 'truck-loading'],
          }
        case 1:
          return {
            text: this.small
              ? this.$t('components.productStockStatus.outOfStockShortText')
              : this.$t('components.cartProductList.outOfStock'),
            icon: ['fal', 'times'],
          }
        default:
          return { text: '', icon: [] }
      }
    },
  },
}
